module.exports = __webpack_public_path__ + "static/media/DESTINATION-WEDDINGS-IN-PORTUGAL-SUPERIOR-LUXURY-SEA-VIEW.a796dc04.jpg";